"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const timing = {
    timingXslow: '1000ms',
    timingSlow: '900ms',
    timingMedium: '300ms',
    timingFast: '150ms',
    timingXfast: '100ms',
};
exports.default = timing;
